// In your React component file
import React from 'react';

const TranslateWidget = () => {
  return <div id="google_translate_element" style={{marginLeft:'10px',marginTop:'0px', marginBottom:'0px', border:'1px solid #ccc', padding:'0px'}}></div>;
};

export default TranslateWidget;
